import Axios from "axios";

import { GetAccessTokenFunc } from "@digital-services/shell";

Axios.defaults.baseURL = import.meta.env.VITE_APP_BACKEND_API_URL;

const scope = import.meta.env.VITE_APP_BACKEND_API_SCOPE as string;

export const fetcher = async (
  url: string,
  getAccessToken: GetAccessTokenFunc
) => {
  const token = await getAccessToken([scope]);

  const res = await Axios.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  });

  return res.data;
};

export const headRequest = async (
  url: string,
  getAccessToken: GetAccessTokenFunc
) => {
  try {
    const token = await getAccessToken([scope]);
    const response = await Axios.head(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.status === 200;
  } catch (error) {
    if (Axios.isAxiosError(error)) {
      console.error("Request failed:", error.response?.status, error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};
